import { fmtMoney } from "@/lib/api";
import { CondBadge } from "@/components/moveout/MoveOutItemRow";
import { ChecklistPhotos } from "@/components/movein/ChecklistPhotos";
import { ClipboardList } from "lucide-react";

export function MoveOutCompare({ inspection, photoBase }) {
  const paths = { upload: () => "", view: (pid) => `/move-out/${inspection.id}/photos/${pid}`, remove: () => "" };
  const miPaths = (mid) => ({ upload: () => "", view: (pid) => `/move-in/${mid}/photos/${pid}`, remove: () => "" });
  return (
    <div className="space-y-5" data-testid="moveout-compare">
      {inspection.rooms.map((room) => (
        <div key={room.key} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`moveout-room-${room.key}`}>
          <div className="flex items-center gap-2 mb-2"><ClipboardList className="h-5 w-5 text-primary" /><h3 className="font-display font-bold text-lg text-slate-900">{room.label}</h3></div>
          <div className="hidden sm:grid grid-cols-[1fr_110px_110px_110px] gap-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400 pb-1 border-b border-slate-100">
            <span>Item</span><span>Move-in</span><span>Move-out</span><span className="text-right">Deduction</span>
          </div>
          {room.items.map((it) => {
            const id = `${room.key}-${it.key}`;
            return (
              <div key={it.key} className="py-3 border-b border-slate-100 last:border-0" data-testid={`moveout-compare-${id}`}>
                <div className="grid sm:grid-cols-[1fr_110px_110px_110px] gap-2 items-center">
                  <span className="text-sm font-semibold text-slate-800">{it.label}</span>
                  <span><span className="sm:hidden text-xs text-slate-400 mr-1">In:</span><CondBadge c={it.move_in?.condition} /></span>
                  <span><span className="sm:hidden text-xs text-slate-400 mr-1">Out:</span><CondBadge c={it.condition} testid={`moveout-compare-cond-${id}`} /></span>
                  <span className={`text-right font-mono text-sm font-semibold ${it.deduction > 0 ? "text-rose-600" : "text-slate-300"}`} data-testid={`moveout-compare-deduction-${id}`}>{it.deduction > 0 ? fmtMoney(it.deduction) : "—"}</span>
                </div>
                {(it.move_in?.note || it.note) && (
                  <div className="text-xs text-slate-600 mt-1 space-y-0.5">
                    {it.move_in?.note && <div><span className="text-slate-400">Move-in:</span> {it.move_in.note}</div>}
                    {it.note && <div><span className="text-slate-400">Move-out:</span> {it.note}</div>}
                  </div>
                )}
                <div className="flex flex-wrap gap-4">
                  {it.move_in?.photos?.length > 0 && inspection.move_in_id && (
                    <div><div className="text-[10px] font-semibold uppercase text-slate-400 mt-2">Move-in photos</div>
                      <ChecklistPhotos checklistId={inspection.move_in_id} roomKey={room.key} item={it.move_in} locked onChange={() => {}} paths={miPaths(inspection.move_in_id)} /></div>
                  )}
                  {it.photos?.length > 0 && (
                    <div><div className="text-[10px] font-semibold uppercase text-slate-400 mt-2">Move-out photos</div>
                      <ChecklistPhotos checklistId={inspection.id} roomKey={room.key} item={it} locked onChange={() => {}} paths={paths} /></div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ))}
      {inspection.general_note && (
        <div className="rounded-2xl border border-slate-200 bg-white p-5"><h3 className="font-display font-bold text-slate-900 mb-1">Inspector's comments</h3><p className="text-sm text-slate-600 whitespace-pre-wrap" data-testid="moveout-general-note">{inspection.general_note}</p></div>
      )}
    </div>
  );
}
